import {http} from '@/utils/http'
import {AxiosResponse} from "axios";
import {IProfile} from "@/features/auth/auth.types";

export const authService = {
    login(payload: any) {
        return http.post('/auth/login', payload)
    },

    logout() {
        return http.post('/auth/logout')
    },

    createAdmin(payload: any) {
        return http.post('/auth/create_admin', payload)
    },

    profileInfo(): Promise<AxiosResponse> {
        return http.get<IProfile>('/auth/me')
    }
}